var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-input',{attrs:{"placeholder":_vm.field?.dynamicFieldDescribed || '',"maxlength":"50"},on:{"input":_setup.handleInput},model:{value:(_setup.inputValue),callback:function ($$v) {_setup.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }